var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useMergeRefs } from '@floating-ui/react';
import { useEffect, useRef } from 'react';
import { ENTER_KEY, SPACE_KEY } from '#constants';
import { C } from '#integrations';
import { useDatePickerContext } from '../../context/useDatePickerContext';
import { DAYS_PER_WEEK } from '../../DatePicker.constants';
import { datesAreEqual, getDateProps } from '../../DatePicker.services';
import { DatePickerTestIdFactory } from '../../interactions';
import { formatDate } from '../DateInput/DateInput.services';
import styles from './Day.module.css';
const getDayStyles = ({ isDisabled, isInCurrentMonth, isSelected, isToday, }) => {
    // marks current day
    const dotStyles = isToday &&
        C(styles.Dot, isSelected ? styles.CurrentDayDotSelected : styles.CurrentDayDot, isDisabled && styles.CurrentDayDotDisabled);
    const dayInMonthColor = isInCurrentMonth
        ? isSelected
            ? styles.SelectedDayColor
            : styles.DayInMonthColor
        : styles.DayOtherMonthColor;
    const dayInMonthBackground = C(styles.Day, isSelected && styles.DaySelected);
    const disabledDay = isDisabled && styles.DayDisabled;
    return [dotStyles, dayInMonthColor, dayInMonthBackground, disabledDay];
};
export const Day = ({ 'data-testid': testId, dayIndex, weekIndex, }) => {
    _react_refresh_temp_2();
    const elementRef = useRef(null);
    const { displayDates, focusedDate, focusedDayRef, id, max, min, onSelectDate, value, } = useDatePickerContext();
    const displayIndex = weekIndex * DAYS_PER_WEEK + dayIndex;
    const date = displayDates[displayIndex];
    const { isDisabled, isInCurrentMonth, isSelected, isToday } = getDateProps({
        date,
        focusedDate,
        selectedDate: value,
        min,
        max,
    });
    const dayStyles = getDayStyles({
        isDisabled,
        isInCurrentMonth,
        isSelected,
        isToday,
    });
    const isFocusedDay = Boolean(focusedDate) && datesAreEqual(date, focusedDate);
    // Expose the focused day's cell so the popup can focus it when it opens.
    const mergedRef = useMergeRefs([elementRef, focusedDayRef ?? null]);
    useEffect(() => {
        if (datesAreEqual(date, focusedDate)) {
            elementRef.current?.setAttribute('tabindex', '0');
            // Only focus a date in the Calendar
            // if the focus is already in the Calendar itself.
            if (!document.activeElement?.closest('[data-calendar-header]')) {
                elementRef.current?.focus();
            }
        }
        else {
            elementRef.current?.setAttribute('tabindex', '-1');
        }
    }, [date, focusedDate, value]);
    return (_jsx("td", { ...(isToday && { 'aria-current': 'date' }), "aria-describedby": `${id}-calendar-header`, ...(isDisabled && { 'aria-disabled': true }), "aria-selected": isSelected, className: C(styles.Day, ...dayStyles), "data-testid": DatePickerTestIdFactory.getDatePickerDayTestId(formatDate(date), testId), onClick: (event) => {
            event.preventDefault();
            if (!isDisabled) {
                onSelectDate(date);
            }
        }, onKeyDown: (event) => {
            if ([ENTER_KEY, SPACE_KEY].includes(event.key) && !isDisabled) {
                event.preventDefault();
                onSelectDate(date);
            }
        }, ref: isFocusedDay ? mergedRef : elementRef, tabIndex: isFocusedDay ? 0 : -1, children: date.getDate() }));
};
_react_refresh_temp_1 = Day;
$RefreshReg$(_react_refresh_temp_1, "Day");
_react_refresh_temp_2(Day, "wHV2M0SN9BA9LEVXe+eC0g1YOI4=", false, () => [useDatePickerContext, useMergeRefs]);
